import React, { useState, useEffect ,useRef } from "react";
import EnquiryForm from "./EnquiryForm"; 
import EnquiryCartIcon from "./EnquiryCartIcon"; 
const PopupCart = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formFields, setFormFields] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [loadingItemId, setLoadingItemId] = useState(null);

  useEffect(() => {
    if (cartItems.length === 0) {
      setIsOpen(false);
    }
  }, [cartItems]);
  useEffect(() => {
    if (isOpen === true) {
      fetchCartItems();
    }
  }, [isOpen]);

  useEffect(() => {
    fetchCartItems();
    if (window.gmpqcw_wp_ajax && window.gmpqcw_wp_ajax.gmpqcw_fields) {
      parseFormFields(window.gmpqcw_wp_ajax.gmpqcw_fields);
    }
  }, []);

  useEffect(() => {
    const handleCartUpdate = () => {
      fetchCartItems(); // Reload the cart when item is added
      setIsOpen(true);
    };

    window.addEventListener('cartUpdated', handleCartUpdate);

    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, []);

  const parseFormFields = (fieldsObj) => {
    const fieldsArray = Object.keys(fieldsObj).map((key) => ({
      name: key,
      ...fieldsObj[key],
    }));
    setFormFields(fieldsArray);
  };

  const fetchCartItems = async () => {
    try {
      const response = await fetch(window.gmpqcw_wp_ajax.cart_items);
      const data = await response.json();
      setCartItems(data);
    } catch (error) {
      console.error("Error loading floating cart:", error);
    }
  };

  
  const handleRemove = async (productId) => {
    setLoadingItemId(productId);
    try {
      const response = await fetch(window.gmpqcw_wp_ajax.remove_from_cart, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": window.gmpqcw_wp_ajax.nonce,
        },
        body: JSON.stringify({ product_id: productId }),
      });
      const result = await response.json();
      if (result.msg === "success") {
        setCartItems(cartItems.filter((item) => item.id !== productId));
      } else {
        alert("Error: " + result.returnhtml);
      }
    } catch (error) {
      console.error("Error removing item:", error);
    } finally {
      setLoadingItemId(null);
    }
  };

 
  const closeCartPopup = () => {
    setIsOpen(false);
    setSuccessMessage(null);
  };

  return (
    <>
      {cartItems.length > 0 && (
        <a
            href="#"
            className="floating-cart-button"
            onClick={() => setIsOpen(true)}
            aria-label="Toggle Enquiry Cart"
          >
                     <EnquiryCartIcon/>

          </a>


      )}

      {isOpen && <div className="floating-cart-overlay"  onClick={closeCartPopup} />}
      
      {isOpen && (
        <div className={`floating-cart-panel open`}>
          <div>
          <button className="close-button" onClick={closeCartPopup}></button>
          </div>
          {successMessage ? (
              <div className="gmpqcw-success">{successMessage}</div>
            ) : (
              <>
                <div className="cart-header">
                  <h3> {window.gmpqcw_wp_ajax?.gmpqcw_translation?.gmpqcw_trasnlation_popup_title?.val || "Your Enquiry Cart"}</h3>
                </div>
                <div className="floating-cart-panel-inner">
                  
                      <div className="cart-content">
                        {cartItems.length === 0 ? (
                          <p className="gmpqcw-loader">Loading your cart...</p>
                        ) : (
                          cartItems.map((item) => (
                            <div className="gmpqcw-cart-card" key={item.id}>
                              <img src={item.image || "/placeholder.png"} alt={item.name} className="gmpqcw-cart-img" />
                              <div className="gmpqcw-cart-info">
                                <h4>{item.name}</h4>
                                <button
                                  className="gmpqcw-remove-btn"
                                  onClick={() => handleRemove(item.id)}
                                  disabled={loadingItemId === item.id}
                                >
                                  {loadingItemId === item.id ? "Removing..." : "Remove"}
                                </button>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                      <EnquiryForm
                        formFields={formFields}
                        setSuccessMessage={setSuccessMessage}
                      />
                  
                </div>
          </>
          )}
        </div>
      )}
    </>
  );
};

export default PopupCart;
